import './Contact.css';

function Contact() {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-lg border-0 rounded-lg">
            <div className="card-body p-5">
              <h1 className="card-title text-center mb-5 fw-bold text-primary">Get in Touch</h1>
              
              <div className="contact-info mb-5">
                <div className="d-flex align-items-center mb-4 contact-item">
                  <div className="contact-icon-wrapper me-3">
                    <i className="bi bi-telephone-fill text-primary fs-4"></i>
                  </div>
                  <div>
                    <h6 className="mb-0 fw-bold">Phone</h6>
                    <span className="text-muted">+967 776 495 621</span>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4 contact-item">
                  <div className="contact-icon-wrapper me-3">
                    <i className="bi bi-envelope-fill text-primary fs-4"></i>
                  </div>
                  <div>
                    <h6 className="mb-0 fw-bold">Email</h6>
                    <span className="text-muted">wailobadi98@gmail.com</span>
                  </div>
                </div>
              </div>

              <form>
                <div className="mb-4">
                  <label htmlFor="name" className="form-label fw-bold">Name</label>
                  <input 
                    type="text" 
                    className="form-control form-control-lg bg-light" 
                    id="name" 
                    name="name" 
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="email" className="form-label fw-bold">Email</label>
                  <input 
                    type="email" 
                    className="form-control form-control-lg bg-light" 
                    id="email" 
                    name="email" 
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="message" className="form-label fw-bold">Message</label>
                  <textarea 
                    className="form-control form-control-lg bg-light" 
                    id="message" 
                    name="message" 
                    rows="5"
                  ></textarea>
                </div>
                <div className="d-grid">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-lg hover-shadow"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact; 